export const LIGHTSPARK_ENTITY_VALUES = [
  'Lightspark Group, Inc.',
  'Lightspark Payments, LLC',
  'Lightspark Payments Europe AS',
  'Lightspark Europe OÜ',
  'Spark Protocol, LLC',
  'Lastbit, LLC',
];

export function optionWithPlaceholder(options, label) {
  return [{ value: '', label }, ...options];
}

export function optionLabel(options, value, fallback = value) {
  if (!value) return fallback;
  return options.find((option) => option.value === value)?.label || fallback;
}

export const LIGHTSPARK_ENTITY_OPTIONS = optionWithPlaceholder(
  LIGHTSPARK_ENTITY_VALUES.map((entity) => ({ value: entity, label: entity })),
  'Select entity...'
);

export const LIGHTSPARK_ENTITY_FILTER_OPTIONS = optionWithPlaceholder(
  LIGHTSPARK_ENTITY_VALUES.map((entity) => ({ value: entity, label: entity })),
  'All Lightspark entities'
);

export const CONTRACT_TYPE_FALLBACK_OPTIONS = [
  'Master Services Agreement',
  'Consulting Agreement',
  'Non-Disclosure Agreement',
  'Statement of Work',
  'License Agreement',
  'Data Processing Agreement',
  'Order Form',
  'Partnership Agreement',
  'Terms of Service',
  'Amendment',
  'Other',
].map((type) => ({ value: type, label: type }));

export const RENEWAL_TYPE_OPTIONS = [
  { value: 'fixed_term', label: 'Fixed term' },
  { value: 'auto_renew', label: 'Auto renew' },
  { value: 'evergreen', label: 'Evergreen' },
  { value: 'month_to_month', label: 'Month-to-month' },
];

export const RENEWAL_TYPE_DETAIL_OPTIONS = optionWithPlaceholder(RENEWAL_TYPE_OPTIONS, '—');

// Which party gave notice of non-renewal (doc-375). Setting a non-renewal
// notice tells the expiry sweep to stop auto-renewing and let the contract
// expire at term end.
export const NON_RENEWAL_PARTY_OPTIONS = [
  { value: 'lightspark', label: 'Lightspark' },
  { value: 'counterparty', label: 'Counterparty' },
];

export const NON_RENEWAL_PARTY_DETAIL_OPTIONS = optionWithPlaceholder(NON_RENEWAL_PARTY_OPTIONS, '—');

export const PAYMENT_TERM_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'net_30', label: 'Net 30' },
  { value: 'net_45', label: 'Net 45' },
  { value: 'net_60', label: 'Net 60' },
  { value: 'upon_receipt', label: 'Upon receipt' },
  { value: 'other', label: 'Other' },
];

export const PAYMENT_TERM_DETAIL_OPTIONS = optionWithPlaceholder(PAYMENT_TERM_OPTIONS, '—');

export const FEE_FREQUENCY_OPTIONS = [
  { value: 'one_time', label: 'One-time' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'annual', label: 'Annual' },
  { value: 'usage_based', label: 'Usage-based' },
];

export const FEE_FREQUENCY_DETAIL_OPTIONS = optionWithPlaceholder(FEE_FREQUENCY_OPTIONS, '—');

export const DRAFT_SOURCE_OPTIONS = [
  { value: '', label: '(not a draft)' },
  { value: 'our draft', label: 'Our draft (our paper)' },
  { value: 'their draft', label: 'Their draft (counterparty paper)' },
  { value: 'our redline', label: 'Our redline (marks by us)' },
  { value: 'their redline', label: 'Their redline (marks by counterparty)' },
  { value: 'negotiated', label: 'Negotiated (diverges from both templates)' },
];

export const DRAFT_SOURCE_DETAIL_OPTIONS = [
  { value: '', label: '—' },
  ...DRAFT_SOURCE_OPTIONS.filter((option) => option.value),
];

export const CONFIDENTIALITY_STRUCTURE_OPTIONS = [
  { value: '', label: '(not specified)' },
  { value: 'mutual', label: 'Mutual' },
  { value: 'one_way', label: 'One-way' },
];

export const CONTRACT_CATEGORY_OPTIONS = [
  { value: 'Customer Agreement', label: 'Customer Agreement' },
  { value: 'Grid Switch Partner', label: 'Grid Switch Partner' },
  { value: 'Vendor Agreement', label: 'Vendor Agreement' },
];
